/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { UserAudioSegmentationComponent } from '@karya/core';
import React from 'react';
import { ParsedParams } from '@karya/generic-task-react';
import { AudioRenderer } from '../common/Audio';
import { ComponentRendererProps } from '../ComponentRenderer';

type AudioSegment = {
  start: number;
  end: number;
};
export function UserAudioSegmentRenderer(props: ComponentRendererProps) {
  const typedParams = props.node.params as ParsedParams<UserAudioSegmentationComponent>;
  const segments = typedParams.segments ?? [
    { start: 800, end: 2000 },
    { start: 3500, end: 6000 },
    {
      start: 7000,
      end: 9500,
    },
  ];

  return (
    <React.Fragment>
      {segments?.map((segment: AudioSegment, index) => {
        return <AudioRenderer src={typedParams.recording} start={segment.start} end={segment.end} key={index} />;
      })}
    </React.Fragment>
  );
}
